import "./ClientDashboardTabletComponent.scss";
import {IComponentOptions} from "angular";
import {ClientDashboardModel} from "../models/ClientDashboardModel";

export const ClientDashboardTablet = "tfClientDashboardTablet";

export function clientDashboardTablet(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/tablet/ClientDashboardTabletComponent.html`,
        bindings: {
            model: "<"
        },
        controllerAs: "ctrl",
        controller: ClientDashboardTabletComponentController
    };
}

export class ClientDashboardTabletComponentController {
    public model: ClientDashboardModel;
}
